/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';

// Auto adjust enabled

export const changeClusterBaselineAutoAdjust = createAction(
  '[Cluster] Toggle cluster baseline mode',
  props<{ clusterId: string; baselineAutoAdjustEnabled: boolean }>(),
);

export const changeCurrentClusterBaselineAutoAdjust = createAction(
  '[Cluster] Toggle current cluster baseline mode',
  props<{ baselineAutoAdjustEnabled: boolean }>(),
);
export const changeClusterBaselineAutoAdjustOk = createAction(
  '[Cluster] Toggle cluster baseline mode OK',
  props<{ clusterId: string; baselineAutoAdjustEnabled: boolean; notification: string }>(),
);
export const changeClusterBaselineAutoAdjustErr = createAction(
  '[Cluster] Toggle current cluster baseline mode error',
  props<GmcError & { clusterId: string; baselineAutoAdjustEnabled: boolean }>(),
);

// Auto adjust timeout

export const changeCurrentClusterBaselineAutoAdjustTimeout = createAction(
  '[Cluster] Change current cluster baseline auto adjust timeout',
  props<{ baselineAutoAdjustTimeout: number }>(),
);
export const changeClusterBaselineAutoAdjustTimeout = createAction(
  '[Cluster] Change baseline auto adjust timeout',
  props<{ clusterId: string; baselineAutoAdjustTimeout: number }>(),
);
export const changeClusterBaselineAutoAdjustTimeoutOk = createAction(
  '[Cluster] Change baseline auto adjust timeout OK',
  props<{ clusterId: string; baselineAutoAdjustTimeout: number; notification: string }>(),
);
export const changeClusterBaselineAutoAdjustTimeoutErr = createAction(
  '[Cluster] Change cluster auto adjust timeout error',
  props<GmcError & { clusterId: string; baselineAutoAdjustTimeout: number }>(),
);

// Baseline nodes

export const setCurrentClusterBaselineNodes = createAction(
  '[Cluster] Set current cluster baseline nodes',
  props<{ baselineNodeConsistentIds: string[] }>(),
);
export const setClusterBaselineNodes = createAction(
  '[Cluster] Set cluster baseline nodes',
  props<{ clusterId: string; baselineNodeConsistentIds: string[] }>(),
);
export const setClusterBaselineNodesOk = createAction(
  '[Cluster] Set cluster baseline nodes OK',
  props<{ clusterId: string; baselineNodeConsistentIds: string[]; notification: string }>(),
);
export const setClusterBaselineNodesErr = createAction(
  '[Cluster] Set cluster baseline nodes error',
  props<GmcError & { clusterId: string; baselineNodeConsistentIds: string[] }>(),
);
